import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthLoginService } from 'src/app/page/auth-page/service/auth-login.service';
import { EvaluationMspInterface } from 'src/app/util/interfaces/evaluationMsp';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root',
})
export class MysupportEvaluationService {
	private postMysupportEvaluationURL = environment.baseApiUrl + 'mysupportEvaluation';

	constructor(
		private httpClient: HttpClient,
		private AuthLoginService: AuthLoginService
	) {}

	postMysupportEvaluation(data: EvaluationMspInterface): Observable<any> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		const body = {
			evaluation: data.evaluation,
			description: data.description,
			cmdb: data.cmdb,
			cockpit: data.cockpit,
			register: data.register,
			knowledge: data.knowledge,
			report: data.report,
			stock: data.stock,
			request: data.request,
		};

		return this.httpClient.post(this.postMysupportEvaluationURL, body, { headers: headers });
	}
}
